import LinearProgress from '@mui/material/LinearProgress';
import React, {useContext, useEffect, useState} from "react";
import JobForm from "../../../Components/Forms/Pages/HR/Job/JobForm";
import strings from "../../../localization";
import DrawerContext from "../../../Context/DrawerContext";
import {useForm} from "react-hook-form";
import { editJob, getJobData } from "../../../Services/HR/JobService";
import {Paper} from "@mui/material";
import { useSelector } from "react-redux";
import { getHRSettings } from "../../../Services/HR/HRSettingsService";
import SnackbarContext from "../../../Context/SnackbarContext";
import PipelineType from '../../../Constants/Company/PipelineType';

const formRules = {
    'name': {required: true},
    'pipeline': {required: true},
}

const EditJob = (props) => {
    const auth = useSelector((state) => state.auth)
    const {setDrawerTitle} = useContext(DrawerContext);
    const { showMessage } = useContext(SnackbarContext);
    const form = useForm({
        defaultValues: props.data && props.data.length > 0 ? {...props.data[0], paymentFrequency: {id: props.data[0].paymentFrequency}} : undefined
    });
    const {data, control, handleSubmit, getValues, setValue, formState: {errors}} = form;
    const [showLoader, setShowLoader] = useState(false);
    const [pipelines, setPipelines] = useState([]);
    const [partners, setPartners] = useState([]);
    const [currencies, setCurrencies] = useState([]);
    const [userPositions, setUserPositions] = useState([]);
    const [jobStatuses, setJobStatuses] = useState([]);
    const [jobContractTypes, setJobContractTypes] = useState([]);
    const [internalHrOnly,setInternalHrOnly] = useState(false);

    useEffect(() => {
        setDrawerTitle(strings.pages.hr.job.editJob.pageTitle);
    })

    useEffect(() => {
        fetch();
    }, [])

    const fetch = () => {
        getJobData({pipelineType:PipelineType.HR}).then(response => {
            if (!response || !response.ok){
                return;
            }
            setPipelines(response.data.pipelines);
            setPartners(response.data.partners);
            setCurrencies(response.data.currencies);
            setUserPositions(response.data.userPositions);
            setJobStatuses(response.data.jobStatuses);
            setJobContractTypes(response.data.jobContractTypes);
        })

        getHRSettings(auth.company.id).then(response => {
            if(!response || !response.ok) {
                return;
            }
            setInternalHrOnly(response.data.entity.internalHrOnly);
        })
    }

    const onSubmit = (data) => {
        setShowLoader(true);

        editJob(data).then(response => {
            setShowLoader(false);

            if (!response || !response.ok){
                showMessage(strings.commonMessages.errorEditing, 'error');
                props.onFinish();
                return;
            }

            showMessage(strings.commonMessages.editingSuccessful, 'success');
            props.onFinish();
        });
    }

    const onCancel = () => {
        props.onCancel();
    }

    return <div className='drawer-form'>
        <Paper className='paper'>
            {
                showLoader &&
                <LinearProgress />
            }
            <JobForm
                control={control} formRules={formRules}
                values={getValues()} setValue={setValue}
                data={data} errors={errors} form={form}
                jobStatuses={jobStatuses} jobContractTypes={jobContractTypes}
                userPositions={userPositions} pipelines={pipelines}
                currencies={currencies} partners={partners}
                internalHrOnly={internalHrOnly}
                onSubmit={handleSubmit(onSubmit)} onCancel={() => onCancel()}
            />
        </Paper>
    </div>
}

export default EditJob;